<template>
  <div class='companyDevelopt-container'>
    <header-layout activeIndex="companyDevelopt"></header-layout>
    <div class="companyDevelopment-bg1">
      <div class="companyDevelopment-bg2">
<!--        <div class="num-list">
          <countTo :startVal='0' :endVal='108' :duration='3000'></countTo>
          <div class="font16" style="font-weight: 500">我们获得的各类专项荣誉</div>
        </div>
        <div class="num-list">
          <countTo :startVal='0' :endVal='242' :duration='3000'></countTo>
          <div class="font16" style="font-weight: 500">我们获取的各类研究专利</div>
        </div>
        <div class="num-list">
          <countTo :startVal='0' :endVal='549' :duration='3000'></countTo>
          +
          <div class="font16" style="font-weight: 500">与我们建立合作的客户</div>
        </div>-->

      </div>
      <img src="../../assets/img/companyDevelopt/gs_04.jpg" class="bg2-rowImg" width="100%"/>

      <div class="" id="honour">

        <div style="margin: 10px 200px">
          <el-carousel :interval="10000" height="700px">
            <el-carousel-item v-for="item in ryList" :key="item">
              <el-image :src="item" fit="cover"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="">
<!--        <el-image :src="w_23"></el-image>-->
      </div>
    </div>
    <el-footer style='padding:0;'>
      <footer-layout></footer-layout>
    </el-footer>

  </div>
</template>

<script>
import HeaderLayout from '@/components/pc/HeaderLayout.vue';
import FooterLayout from '@/components/pc/FooterLayout.vue';
import CountTo from 'vue-count-to'

export default {
  name: "",
  components: {HeaderLayout, FooterLayout, CountTo},
  data() {
    return {
      activeIndex: "",
      w_12: require('../../assets/img/home/w_12.jpg'),
      w_23: require('../../assets/img/home/w_23.png'),
      ryList: [
        require('../../assets/img/home/ry1.png'),
        require('../../assets/img/home/ry2.png'),
      ],
    }
  },
  mounted() {

  },
  methods: {}
}
</script>

<style lang='scss' scoped>
.companyDevelopt-container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  background-color: #ffffff;
}

.companyDevelopment-bg1 {
  background-color: #F7F8FB;
  width: 100%;
}

.companyDevelopment-bg2 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 600px;
  background-image: url("../../assets/img/companyDevelopt/gs_02.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  font-size: 100px;
  color: #ffffff;
  font-weight: bold;
}

.num-list {
  width: 400px;
}
</style>
